import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

import {UserModel} from '../../models/user.model';

type UserAvatarUser = Pick<UserModel, 'first_name' | 'image' | 'last_name'>;

@Component({
  standalone: true,
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./user-avatar.component.css'],
})
export class UserAvatarComponent {
  private failedImageUrl: string = '';

  @Input() fallbackInitials: string = '?';
  @Input() tone: 'dark' | 'light' | 'primary' = 'dark';
  @Input() user: UserAvatarUser | null = null;
  @Input() size: 'small' | 'large' = 'large';

  protected get imageUrl(): string {
    const imageUrl = this.user?.image?.thumbnail_url || this.user?.image?.url || '';

    return imageUrl === this.failedImageUrl ? '' : imageUrl;
  }

  protected get userName(): string {
    return [this.user?.first_name, this.user?.last_name].filter(Boolean).join(' ').trim();
  }

  protected get initials(): string {
    const firstInitial = this.user?.first_name?.trim().charAt(0) ?? '';
    const lastInitial = this.user?.last_name?.trim().charAt(0) ?? '';
    const initials = `${firstInitial}${lastInitial}`.toUpperCase();

    return initials || this.fallbackInitials;
  }

  protected handleUserAvatarImageError(): void {
    this.failedImageUrl = this.imageUrl;
  }
}
